@if (!isMobileApp) {

<!-- Desktop / Web Application Wrapper -->
<ion-app class="main_app">

  <!-- Top header shown only when user is logged in -->
  @if (isLoggedIn) {
  <app-main-header class="mainHeader" [isMobileApp]="isMobileApp" [driverData]="driverData" [isLoggedIn]="isLoggedIn" [disabled]="isMenuDisabled"
    (logout)="logout()">
  </app-main-header>
  }

  <!-- Desktop layout with side menu and routed content -->
  <ion-split-pane when="xl" class="side_menu horizontal-center split-container" [ngClass]="{
    'login':isLoggedIn,
    'mobile': isMobileApp
  }" contentId="my-content">

    <!-- Side navigation menu for logged-in users -->
    @if (isLoggedIn) {
    <ion-menu contentId="my-content" [side]="menuDirection" type="overlay" id="appSideMenu">

      <ion-content class="side-navigation" scroll-y="false">
        <ion-list class="ion-no-padding ion-no-margin ion-padding-top h-100 overflow-y-scroll">

          <!-- Main navigation menu -->
          <app-main-menu [tabs]="menuItems" [menuDirection]="menuDirection" [isMobileApp]="isMobileApp"
            [disabled]="isMenuDisabled" (emitLogout)="logout()">
          </app-main-menu>

        </ion-list>
      </ion-content>
    </ion-menu>
    }

    <!-- Routed page content -->
    <ion-router-outlet id="my-content"></ion-router-outlet>

  </ion-split-pane>

  <!-- Footer shown after login -->
  @if (!footerFlag) {
  <app-main-footer class="position-fixed bottom-0 w-100">
  </app-main-footer>
  }
</ion-app>

} @else {

<!-- Mobile Application Wrapper -->
<ion-app class="main_app">

  <!-- Bottom navigation menu for mobile -->
  <app-mobile-menu [staticMenuItems]="staticMenuItems" [menuTabs]="menuTabs" [isLoggedIn]="isLoggedIn"
    (emitLogOut)="logout()">
  </app-mobile-menu>

</ion-app>

}

<!-- Global loading overlay -->
@if (loaderService.readIsLoading()) {
<app-loader></app-loader>
}